import { render } from "./Satoshi.vue?vue&type=template&id=b05b72cc&scoped=true"
const script = {}

import "./Satoshi.vue?vue&type=style&index=0&id=b05b72cc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b05b72cc"]])

export default __exports__